import React from "react";
import UserInfo from "../interface/UserInfo";
import useGetUserHook from "../hooks/useGetUserHook";

type UsersContextProps = {
    users: UserInfo[] | undefined;
    isUsersFetching: boolean;
    refetchUsers: () => void;
};

const UserContext = React.createContext<UsersContextProps>(null!);

export function UsersProvider({ children }: { children: React.ReactNode }) {
    const { users, isUsersFetching, refetchUsers} = useGetUserHook();

    return (
        <UserContext.Provider value={{
            users, isUsersFetching, refetchUsers
        }}>
            {children}
        </UserContext.Provider>
    );
}

export function useUsersContext() {
    return React.useContext(UserContext);
}